import BaseService from './base.service';

export default class DashboardService extends BaseService {
  /* eslint-disable camelcase */
  getUspsEmails(organizationUuid, locationUuid, params = {}) {
    const { per_page, page } = params;
    let query = '';

    if (locationUuid) {
      query = `?location=${locationUuid}`;
    }
    if (per_page || per_page === 0) {
      query = `${query ? '&' : '?'}per_page=${per_page}`;
    }
    if (page || page === 0) {
      query += `${query ? '&' : '?'}page=${page}`;
    }
    return this.get(`dashboard/usps/${organizationUuid}${query}`);
  }

  getAllUspsEmails(organizationUuid) {
    return this.get(`dashboard/usps/${organizationUuid}`);
  }

  getEmployeeCompany(companyUuid) {
    return this.get(`employee/company/${companyUuid}`);
  }

  saveConfirmationImage(data) {
    return this.create('super/usps', data);
  }

  saveConfirmationImageBulk(data) {
    return this.create('super/uspsbulk', data);
  }

  uploadFile(data, organizationUuid, time) {
    return this.create(`import/new/${organizationUuid}`, data, time);
  }

  uploadFileVerify(data, organizationUuid) {
    return this.create(`import/dry/${organizationUuid}`, data);
  }

  uploadLettersVerify(data) {
    return this.create('import/importletterfile', data);
  }

  getNews(stateUuid) {
    return this.get(`dashboard/news/${stateUuid}`);
  }

  getAdminStates() {
    return this.get('admin/states/');
  }

  saveAdminNews(uuid, data) {
    return this.create(`admin/news/${uuid}`, data);
  }

  deleteAdminNews(uuid) {
    return this.delete(`admin/news/${uuid}`);
  }

  updateTeamEmployee(companyUuid, data) {
    return this.create(`team/updateEmployee/${companyUuid}`, data);
  }

  getLiens(uuid) {
    return this.get(`lien/view/${uuid}`);
  }

  savePublication(lienTaskUuid, data) {
    return this.create(`super/publication/${lienTaskUuid}`, data);
  }

  getFinalApprovals(organizationUuid) {
    return this.get(`dashboard/final/${organizationUuid}`);
  }

  approveFinalApprovals(data) {
    return this.create('dashboard/final', data);
  }

  updateExecuteDate(lienTaskUuid, data) {
    return this.create(`super/executedtask/${lienTaskUuid}`, data);
  }

  getPrintTemplate(uuid) {
    return this.get(`template/print/${uuid}`);
  }

  saveRenterDescription(renterUuid, data) {
    return this.create(`renter/description/${renterUuid}`, data);
  }

  getLibraryFiles() {
    return this.get('library/list');
  }

  uploadImageToLibrary(data) {
    return this.create('library/upload/image', data);
  }

  uploadPdfToLibrary(data) {
    return this.create('library/upload/pdf', data);
  }

  uploadVideoLinkToLibrary(data) {
    return this.create('library/upload/video', data);
  }

  deleteLibraryItem(itemId) {
    return this.get(`library/delete/${itemId}`);
  }

  getTenantList(data) {
    return this.create('tenant/list', data);
  }

  viewEmail(data) {
    return this.create('tenant/view_email', data);
  }

  saveNewspaperAuctionDate(data) {
    return this.create('dashboard/auction_bulk', data);
  }

  sendEmail(data) {
    return this.create('tenant/send_email', data);
  }

  getAllAvialableFilters(id) {
    return this.create(`view/all_liens_filters/${id}`);
  }

  submitReasonDiscontinueBtn(id, data) {
    return this.create(`renter/manual_discontinue/${id}`, data);
  }

  changeExecutionDate(id, data) {
    return this.create(`lien/change_execution_date/${id}`, { date: data });
  }

  getDashboardStatusColors() {
    return this.get('status/all');
  }

  getHoldCategoryList() {
    return this.get('hold/categories');
  }

  getHoldCategoryListOfLien(lien_uuid) {
    return this.get(`hold/list/${lien_uuid}`);
  }

  getHoldData(hold_id) {
    return this.get(`hold/data/${hold_id}`);
  }

  createHoldCategory(lien_uuid, data) {
    return this.create(`hold/request_hold/${lien_uuid}`, data);
  }

  requestReleaseOfHold(data) {
    return this.create('hold/request_release/', data);
  }

  requestRestartHold(lien_uuid, data) {
    return this.create(`hold/request_restart/${lien_uuid}`, data);
  }

  fetchHoldsData(uuid) {
    return this.get(`hold/restart_steps/${uuid}`);
  }

  rejectReleaseOfHold(data) {
    return this.create('hold/reject/', data);
  }

  approveReleaseOfHold(data) {
    return this.create('hold/release/', data);
  }
}
